// extracted by mini-css-extract-plugin
export default {"root":"Hero_root__0NQlM","link":"Hero_link__TNm1c"};